import { ProjectInfo } from '@infotech-soe/merps/types/session';
import {
  DSAgents,
  KeyTypes,
  SignAlgo,
} from '@infotech-soe/mia-ds-service/types';
import { createSelector } from '@reduxjs/toolkit';

import { AvailableApplication } from '../../services/auth/types';
import { AppState } from '../reducers/root';
import { AuthResult, SessionState, SignFormState } from '../slices/session';

export const getSessionState = (state: AppState): SessionState => state.session;

export const getAuthenticated = (state: AppState): AuthResult =>
  state.session.authenticated;

export const getSessionApplication = (state: AppState): string | null =>
  state.session.application;

export const getAvailableApplications = (
  state: AppState
): AvailableApplication[] => state.session.availableApps;

export const getUserApplications = (state: AppState): AvailableApplication[] =>
  state.session.userApps;

export const getAvailableDSAgents = (state: AppState): DSAgents[] =>
  state.session.availableDSAgents;

export const getAvailableDSKeyTypes = (state: AppState): KeyTypes[] =>
  state.session.availableDSKeyTypes;

export const getAllowedDSMediaTypes = (state: AppState): string | null =>
  state.session.allowedDSMediaTypes;

export const getForbiddenDSMediaTypes = (state: AppState): string | null =>
  state.session.forbiddenDSMediaTypes;

export const getAppDisplayName = createSelector(
  [getAvailableApplications, getSessionApplication],
  (availableApps, application) =>
    availableApps.find(app => app.name === application)?.displayName
);

export const getProjectInfo = (state: AppState): ProjectInfo =>
  state.session.projectInfo;

export const getSignFormState = (state: AppState): SignFormState | undefined =>
  state.session.signFormProps;

export const getUserName = (state: AppState): string | undefined =>
  state.session.userName;

export const getSignAlgo = (state: AppState): SignAlgo | undefined =>
  state.session.signAlgo;
